// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"8079c610","455":"f20fea0e","977":"c5ec6984"}[chunkId] + ".chunk.js";
};